/**
 * Class1Card, sheet 43 callout 5 (mission 10 WP16 T093; FR-017, C-008; D.2, D.3).
 *
 * Register 37 `class1Title` and `class1List`: D.2's Class 1 objects in plain language, the ones the retention
 * window covers. No AgentCore memory claim (Contradictions 5); the encryption sentence is the separate,
 * owner-gated EncryptionStatement (callout 7).
 */
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { copyText } from '@/lib/provisional-copy'

export function Class1Card() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{copyText('class1Title')}</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-body-sm text-navy-700">{copyText('class1List')}</p>
      </CardContent>
    </Card>
  )
}
